import FormHeader from "@/components/FormHeader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api from "@/lib/axios";
import { DataSiswa } from "@/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { Loader2 } from "lucide-react";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { MdModeEdit } from "react-icons/md";

const updateNIK = async ({
  id_data_siswa,
  nik,
}: {
  id_data_siswa: number | undefined;
  nik: string;
}) => {
  const response = await api.patch("/data-siswa/update-nik", {
    id_data_siswa,
    nik,
  });
  return response.data;
};

export default function FormEditNIK({
  selectedRow,
  closeModal,
}: {
  selectedRow: DataSiswa | null;
  closeModal: () => void;
}) {
  const [form, setForm] = useState({
    nik: "",
  });

  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: updateNIK,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["listDataSiswa"] });
      closeModal();
      toast.success(data?.message || "Success.");
    },
    onError: (error: AxiosError) => {
      const err = error as AxiosError<{ message?: string }>;
      toast.error(
        err?.response?.data?.message || "An unexpected error occurred.",
      );
    },
  });

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    mutate({ id_data_siswa: selectedRow?.id_data_siswa, nik: form.nik });
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-y-3">
      <FormHeader title="Update NIK Siswa" icon={<MdModeEdit />} />
      <div>
        <Label>NIK Baru</Label>
        <Input
          placeholder="Masukan NIK baru..."
          value={form.nik}
          onChange={(event) =>
            setForm((prev) => ({ ...prev, nik: event.target.value }))
          }
        />
      </div>

      <div className="mt-3 flex gap-3">
        <Button
          variant={"outline"}
          type="button"
          onClick={closeModal}
          disabled={isPending}
        >
          Batal
        </Button>
        <Button className="flex items-center gap-3" disabled={isPending}>
          {isPending ? (
            <>
              <Loader2 className="w-4 h-4 mr-1 animate-spin" />
              Processing...
            </>
          ) : (
            "Simpan"
          )}
        </Button>
      </div>
    </form>
  );
}
